import { useIntl } from "react-intl";
import { useState } from "react";
import { Combobox, ETypeOfNotification, Modal, setNotification, useFormValidation } from "medere-ui-framework";
import { useDispatch } from 'react-redux';
import { exportBudgetPDF, getBudgetDetailLevels, getBudgetViewModes } from "../../servicesHooks/Budget/useBudgetService";
import { ComboDataDTO, defaultComboDataDTO } from "../../dto/ComboDataDTO";

interface PrintBudgetModalProps {
    budget:number,
    openPrintBudgetModal: boolean;
    setOpenPrintBudgetModal: (open: boolean) => void;
}

interface PrintBudgetModalValidationInterface{
    selectedViewMode: number | undefined;
    selectedDetailLevel: number | undefined;
}

const defaultPrintBudgetModalValidationInterface: PrintBudgetModalValidationInterface = {
    selectedViewMode: -1,
    selectedDetailLevel: -1
}

export default function PrintBudgetModal({budget, openPrintBudgetModal, setOpenPrintBudgetModal}: PrintBudgetModalProps) {

    const dispatch = useDispatch();
    const intl = useIntl();
    const [isMobile] = useState(window.innerWidth <= 768);
    const [selectedViewMode, setSelectedViewMode] = useState<ComboDataDTO>(defaultComboDataDTO);
    const [selectedDetailLevel, setSelectedDetailLevel] = useState<ComboDataDTO>(defaultComboDataDTO);
    const [selectedItems, setSelectedItems] = useState<PrintBudgetModalValidationInterface>(defaultPrintBudgetModalValidationInterface);
   

return (
    <Modal
    visible={openPrintBudgetModal}
    setVisible={setOpenPrintBudgetModal}
    className="nv-scope nv-dialog custom-modal w-auto"
    header={<span className="nv-modal-title">{"Descargar presupuesto en PDF"}</span>}
    footerButtonRightText = {intl.formatMessage({ id: "Download" })}
    onClickRightBtn={()=>{
        exportBudgetPDF(budget, selectedItems.selectedViewMode ?? 1, selectedItems.selectedDetailLevel ?? 1);
    }}
    rightButtonDisabled={selectedItems.selectedViewMode == -1 || selectedItems.selectedDetailLevel == -1}
    closable
    >
        <div style={{ minWidth: isMobile ? "" : "150px" }}>
            <div className="flex flex-column gap-2">
                <p className="nv-muted">{"Configurá el contenido a mostrar en tu presupuesto"}</p>
                <div className="flex flex-row gap-1">
                    <Combobox label={"Destinatario"} 
                        className={`input-common`} 
                        getItems={getBudgetViewModes}
                        optionLabel='name' 
                        placeholder="Seleccionar"
                        value={selectedViewMode.name}
                        setValue={(e:ComboDataDTO) => {
                            setSelectedViewMode(e);
                            setSelectedItems({...selectedItems, selectedViewMode: e.id ?? 1});
                        }} 
                    />
                    <Combobox label={"Valores a mostrar"} 
                        className={`input-common`} 
                        getItems={getBudgetDetailLevels}
                        optionLabel='name' 
                        placeholder="Seleccionar"
                        value={selectedDetailLevel.name}
                        setValue={(e:ComboDataDTO) => {
                            setSelectedDetailLevel(e);
                            setSelectedItems({...selectedItems, selectedDetailLevel: e.id ?? 1});
                        }} 
                    />
                </div>
            </div>
        </div>
    </Modal>
);
}
